import { ListProvider } from './ListProvider';
import List from './List';

const BackList = (): JSX.Element => {
  return (
    <ListProvider>
      <List />
    </ListProvider>
  );
};

export default BackList;
